export default [
    {
        path: 'relatorio-alto-custo-dispensacao',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-alto-custo-dispensacao' */
            '@/views/farmacia/relatorio-alto-custo-dispensacao/Index'
        ),
        redirect: 'relatorio-alto-custo-dispensacao/index',
        children: [
            {
                name: 'farmacia-relatorio-alto-custo-dispensacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-alto-custo-dispensacao' */
                    '@/views/farmacia/relatorio-alto-custo-dispensacao/List'
                ),
            },
        ]
    }
]